<template>
  <div class="page-content conmon-top">
    <div class="base-input ovf-hd" style="margin-bottom: 10px;">
      <el-row class="search-title">
        <el-col :span="4" class="search-nav-left">
          <i class="el-icon-search" style="font-weight: bold;"></i>
          <span class="order-list-search-span">筛选查询</span>
        </el-col>
        <el-col :span="20" class="search-nav-right">
          <el-button class="search-open-close" type="text" @click="hide=!hide" v-show="hide">收起查询</el-button>
          <el-button class="search-open-close" type="text" @click="hide=!hide" v-show="!hide">展开查询</el-button>
          <i v-if="hide === true" class="el-icon-arrow-up search-open-close-i" @click="hide=!hide"></i>
          <i v-if="hide === false" class="el-icon-arrow-down search-open-close-i" @click="hide=!hide"></i>
          <el-button class="search-btn-new" type="primary" size="small" @click="searchData">查询</el-button>
        </el-col>
      </el-row>
      <el-collapse-transition>
        <div v-show="hide" class="search-content common-search-formtype">
          <el-form :inline="true" :model="formInlineTmp" label-width="95px" class="search-content-item">
            <el-form-item label="看板名称：">
              <el-input @keyup.enter.native="searchData" v-model.trim="formInlineTmp.name" placeholder="请输入看板名称" clearable ></el-input>
            </el-form-item>
            <el-form-item label="创建人：">
              <el-input @keyup.enter.native="searchData" v-model.trim="formInlineTmp.createUserName" placeholder="请输入创建人" clearable ></el-input>
            </el-form-item>
          </el-form>
        </div>
      </el-collapse-transition>
    </div>
    <el-row class="search-title common-table-top" style="padding-right:0">
      <el-col :span="4" style="text-align: left;">
        <i class="el-icon-document" style="font-weight: bold;"></i>
        <span class="order-list-search-span">看板列表</span>
      </el-col>
      <el-col :span="20" class="text-align-right">
        <el-button type="primary" @click="dialogVisible = true" class="add-btn btn-right" style="float: right;">新建看板</el-button>
      </el-col>
    </el-row>
    <el-row class="import-data-title table-first-style">
      <el-table
        :data="tableData"
        v-loading="loading"
        class="table">
        <el-table-column
          prop="name"
          label="看板名称">
        </el-table-column>
        <!-- <el-table-column
          prop="des"
          label="看板描述">
        </el-table-column> -->
        <el-table-column
          prop="updateUserName"
          label="修改人"
          width="130">
        </el-table-column>
        <el-table-column
          prop="updateTimeStr"
          label="修改时间"
          width="140">
        </el-table-column>
        <el-table-column
          prop="createUserName"
          label="创建人"
          width="130">
        </el-table-column>
        <el-table-column
          prop="createTimeStr"
          label="创建日期"
          width="140">
        </el-table-column>
        <el-table-column label="操作" width="180" style="display: flex;justify-content: center">
          <template slot-scope="scope">
            <div class="op-link" @click="pushToDashBoardPage(scope.row)">
              详情
            </div>
            <div class="op-link" @click="deleteDashboardAction(scope.row.id)">
              删除
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div class="table-foot">
        <el-pagination
          class="table-foot-pagination"
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :page-size="limit"
          layout="total, prev, pager, next, jumper"
          :total="totalCount">
        </el-pagination>
      </div>
    </el-row>
    <el-dialog
      title="新建看板"
      :visible.sync="dialogVisible"
      width="520px"
      class="cellDialog">
      <el-form :model="addBoardForm" label-width="110px"  ref="addBoardForm" :rules="rules" >
        <el-form-item label="看板名称" prop="name">
          <el-input v-model="addBoardForm.name" placeholder="请输入看板名称(20字以内)" maxlength="20"></el-input>
        </el-form-item>
       <!--  <el-form-item label="看板描述" prop="level_title">
          <el-input type="textarea" rows="6" v-model="addBoardForm.level" placeholder="请输入看板描述(100字)" maxlength="100"></el-input>
        </el-form-item> -->
        <!-- <el-form-item label="查看权限" prop="level">
          <el-cascader
            class="right"
            expand-trigger="hover"
            :options="options"
            v-model="addBoardForm.levels"
            @change="handleChange">
          </el-cascader>
        </el-form-item> -->
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button class="dialog-cancel-btn" style="margin-right: 20px" @click="dialogVisible = false">取 消</el-button>
        <el-button class="dialog-confirm-btn" type="primary" style="margin-right: 20px" @click="submitForm('addBoardForm')">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { getDashBoardList, addDashBoard, deleteDashboard } from '@/api/analyse.js'
export default {
  name: 'boardList',
  data () {
    return {
      myStorage: window.localStorage,
      options: [],
      rules: {
        name: [
          { required: true, message: '请输入看板名称', trigger: 'blur' }
        ]
      },
      addBoardForm: {
        name: ''
      },
      dialogVisible: false,
      formInlineTmp: {
        createUserName: '',
        name: ''
      },
      formInline: {
        createUserName: '',
        name: ''
      },
      loading: false,
      hide: true,
      tableData: [],
      page: 1,
      limit: 10,
      totalCount: 0,
      isSwitchClick: 1,
      memberLevelList: []
    }
  },
  methods: {
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.addDashBoardAction()
        } else {
          return false
        }
      })
    },
    addDashBoardAction() {
      addDashBoard(this.addBoardForm.name).then(res => {
        if (res.data.code === 0) {
          _g.toastMsg('success', res.data.des)
          this.dialogVisible = false
          this.getData()
        } else {
          _g.toastMsg('error', res.data.des)
        }
      })
    },
    handleChange() {},
    searchData() {
      this.formInline = JSON.parse(JSON.stringify(this.formInlineTmp))
      this.page = 1
      this.getData()
    },
    switchChange(row, status) {
      if (this.isSwitchClick === 1) {
        this.isSwitchClick = 0
        this.$nextTick(() => {
          changeNoticeStatus(row.id, status).then((res) => {
            if (res.data.code === 0) {
              _g.toastMsg('success', res.data.error)
            } else {
              _g.toastMsg('error', res.data.error)
            }
            this.isSwitchClick = 1
            this.getData()
          })
        })
      }
    },
    pushToDashBoardPage(item) {
      let layoutArr = []
      let resultArray = []
      this.myStorage.setItem('boardName', item.name)
      this.myStorage.setItem('itemFigures', JSON.stringify(item.figures))
      for (var j = 0; j < item.figures.length; j++) {
        if (item.figures[j].position !== '') {
          let arr = JSON.parse(item.figures[j].position)
          let type = item.figures[j].showType
          layoutArr.push({
            'x': arr[0],
            'y': arr[1],
            'w': arr[2],
            'h': arr[3],
            'i': JSON.parse(item.figures[j].id),
            'showType': type,
            'type': item.figures[j].type,
            'name': item.figures[j].name
          })
        } else {
          layoutArr.push({
            'x': 0,
            'y': 0,
            'w': 6,
            'h': 9,
            'i': JSON.parse(item.figures[j].id),
            'showType': '',
            'type': item.figures[j].type,
            'name': item.figures[j].name
          })
        }
      }
      this.myStorage.setItem('itemLayout', JSON.stringify(layoutArr))
      this.myStorage.setItem('dashBoardId', item.id)
      router.push({ path: '/home/board-details' })
    },
    // 处理分页
    handleSizeChange(val) {
      this.limit = val
      this.getData()
    },
    handleCurrentChange(page) {
      this.page = page
      this.getData()
    },
    deleteDashboardAction(itemId) {
      this.$confirm('确认删除该看板?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        deleteDashboard(itemId).then((res) => {
          if (res.data.code === 0) {
            _g.toastMsg('success', res.data.des)
          } else {
            _g.toastMsg('error', res.data.des)
          }
          this.getData()
        })
      }).catch((error) => {
      })
    },
    getData() {
      this.loading = true
      getDashBoardList(this.page, this.limit, this.formInline.name, this.formInline.createUserName).then(res => {
        if (res.data.code === 0) {
          this.totalCount = res.data.data.total
          this.tableData = res.data.data.data
        } else {
          _g.toastMsg('error', res.data.des)
        }
      })
      this.openLoading()
    },
    // 数据加载时的动画
    openLoading() {
      setTimeout(() => {
        this.loading = false
      }, 500)
    }
  },
  created() {
    this.getData()
  },
  components: {
  }
}
</script>

<style scoped>
.sign-manage-title {
  background: #ecf6ff;
  border: 1px solid #E4e4e4;
  height:60px;
  padding:10px;
  line-height: 40px;
  margin-top: 10px;
}
.table-title {
  text-align: left;
}
.dialog-content {
  height: 200px;
}
.content-one span {
  display: inline-block;
  float: left;
  line-height: 20px;
  font-size: 16px;
  margin-top: 10px;
}
.content-one p {
  text-align: left;
}
.enable-button {
  color: #1980FF;
  cursor: pointer;
  font-size: 14px;
}
.right {
  width: 370px;
}
</style>
